import React from "react"
import { onlyDigitsWithMaxLen, commaSep } from "./helper"
import { InputAdornment, TextField } from "@mui/material"
import { getInputRules } from "./NumberTextField"
import { Controller } from "react-hook-form"

export function toRial(amount) {
  return (amount ? Number(amount).toLocaleString() : 0) + "ریال"
}
export function CurrencyTextField(props) {
  const rules = getInputRules(props)
  const { name, control, maxLength, ...etc } = props
  const elementProps = {}
  if (maxLength) {
    elementProps.onKeyDown = onlyDigitsWithMaxLen(maxLength)
  }
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({
        field: { onChange, name, value },
      }) => {
        return (
          <TextField
            style={{
              direction: "ltr"
            }}
            fullWidth
            {...elementProps}
            {...etc}
            value={value ? commaSep(value + "") : " "}
            onChange={e => {
              onChange(e.target.value)
            }}
            InputProps={{
              endAdornment: <InputAdornment position='end'>ریال</InputAdornment>
            }}
          />
        )
      }}
    />
  )
}
